export const REQUIRED_ERROR = "Required";
export const PLACEHOLDER_TEXT = "Choose an option";
